import crud from './crud'
import roles from './roles'

export default {
    namespaced: true,
    state: {
        ...crud.state,
        ...roles.state,
    },
    mutations: {
        ...crud.mutations,
        ...roles.mutations
    },
    actions: {
        ...crud.actions,
        ...roles.actions
    }
}